import React from "react";
import classNames from "classnames";
import { flatten } from "lodash";

import Checkbox from "./Checkbox";
import AppSettings from "lib/services/AppSettings";

const getChildrenOf = (parentId, tags) =>
  tags.filter((tag) => tag.parent_id === parentId).sort((a, b) => a.position - b.position);

const getAllDescendantsOf = (rootId, tags) => {
  const children = getChildrenOf(rootId, tags);
  return [...children, ...flatten(children.map((child) => getAllDescendantsOf(child.id, tags)))];
};

export default class CategoriesInput extends React.PureComponent {
  handleChange(tagId, enabled) {
    const { value = [], onChange } = this.props;
    if (enabled) {
      onChange && onChange(value.includes(tagId) ? value : value.concat([tagId]));
    } else {
      const descendantsIds = getAllDescendantsOf(tagId, this.tags).map((tag) => tag.id);
      onChange && onChange(value.filter((id) => id !== tagId && !descendantsIds.includes(id)));
    }
  }

  renderTag(tag) {
    const { value = [], onFocus, onBlur, readOnly, disabled } = this.props;

    const children = getChildrenOf(tag.id, this.tags);
    return (
      <div
        key={tag.id}
        className={classNames("c-CategoriesInput-child", {
          active: value.includes(tag.id),
          "has-active-descendant": this._hasActiveDescendant(tag.id),
        })}
      >
        <div className="c-CategoriesInput-item">
          <Checkbox
            checked={value.includes(tag.id)}
            onChange={(checked) => this.handleChange(tag.id, checked)}
            onFocus={onFocus}
            onBlur={onBlur}
            label={children.length > 0 ? `${tag.name} (${children.length})` : tag.name}
            readOnly={readOnly}
            disabled={disabled}
          />
        </div>
        {children.length > 0 && (
          <div className="c-CategoriesInput-children">{children.map((child) => this.renderTag(child))}</div>
        )}
      </div>
    );
  }

  _hasActiveDescendant(id) {
    const { value = [] } = this.props;
    const descendants = getAllDescendantsOf(id, this.tags);
    return descendants.find((tag) => value.includes(tag.id));
  }

  get tags() {
    if (this.props.type === "ProductTag.category") {
      return AppSettings.product_category_tags || [];
    } else if (this.props.type === "ProductTag.location") {
      return AppSettings.product_location_tags || [];
    } else {
      return this.props.tags || [];
    }
  }

  render() {
    const { className } = this.props;
    const roots = getChildrenOf(null, this.tags);
    return <div className={classNames("c-CategoriesInput", className)}>{roots.map((tag) => this.renderTag(tag))}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/CategoriesInput.jsx